import yup from "@/yup";

export function useSchema() {
  return yup.object({
    order: yup.number().integer().min(0),
  });
}

export type ISchema = yup.InferType<ReturnType<typeof useSchema>>;
